import { useRouteError } from 'react-router-dom';

export function RouteErrorBoundary() {
  const error = useRouteError();

  return (
    <div>
      <h1>Something went wrong!</h1>
      <p>{error instanceof Error ? error.message : String(error)}</p>
    </div>
  );
}
